import React from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';

interface Props {
  onCxLinkClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  cxLink: string;
  onCloseOverlay: () => void;
  classes?: any;
}
const AppilyOverlay = ({
  cxLink,
  onCxLinkClick,
  onCloseOverlay,
  classes,
}: Props) => {
  return (
    <div className={classes.overlay}>
      <div className={classes.overlayContent}>
        <div>
          <button
            onClick={onCloseOverlay}
            aria-label={'Close Appily overlay'}
            className={classes.closeButton}
          >
            <img src="images/UI/close.svg" />
          </button>
        </div>
        <span className={classes.overlayText}>
          Don't see the Appily sign in window? We'll help you re-launch the
          window to sign in or create your free account. Be sure that pop-up
          blockers are turned off for this site.
        </span>
        <a
          onClick={onCxLinkClick}
          className={classes.overlayContinue}
          href={cxLink}
          target="_blank"
          rel="noreferrer"
        >
          Click to continue
        </a>
        <img
          className={classes.appilyLogoOverlay}
          src="images/appily_logo_power_white.svg"
        />
      </div>
    </div>
  );
};

export default injectSheet(styleSheet)(AppilyOverlay);
